import { LoomIcon } from '../../../assets/icons/loom';
import { createEmbedProvider } from '../factory';

export const LOOM_REGEX = /^https:\/\/(www\.)?(use)?loom\.com\/(embed|share)\/(.*)$/;

export const loomProvider = createEmbedProvider({
  id: 'loom',
  label: 'Loom Video',
  icon: <LoomIcon className="size-5 fill-current" />,
  regex: LOOM_REGEX,
  buildEmbedUrl: (match) => `https://www.loom.com/embed/${match[4]}`,
});
